import { push } from 'react-router-redux';
import update from 'immutability-helper';
import Notifications from 'react-notification-system-redux';
import { SubmissionError } from 'redux-form';

import { authLoginUserFailure, authUpdateUser } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import {
    uploadProfileImage,
    fetchProfile,
    patchProfile,
    postSetPassword,
  } from './api';
// ------------------------------------
// Constants
// ------------------------------------
export const PROFILE_FETCH_FAILURE = 'PROFILE_FETCH_FAILURE';
export const PROFILE_FETCH_REQUEST = 'PROFILE_FETCH_REQUEST';
export const PROFILE_FETCH_SUCCESS = 'PROFILE_FETCH_SUCCESS';
export const PROFILE_EDIT_FAILURE = 'PROFILE_EDIT_FAILURE';
export const PROFILE_EDIT_REQUEST = 'PROFILE_EDIT_REQUEST';
export const PROFILE_EDIT_SUCCESS = 'PROFILE_EDIT_SUCCESS';
export const PASSWORD_SET_FAILURE = 'PASSWORD_SET_FAILURE';
export const PASSWORD_SET_REQUEST = 'PASSWORD_SET_REQUEST';
export const PASSWORD_SET_SUCCESS = 'PASSWORD_SET_SUCCESS';

// ------------------------------------
// Actions
// ------------------------------------

export function gotoProfile() {
  return (dispatch) => {
    dispatch(push('/profile'));
  };
}
export function gotoProfileEdit() {
  return (dispatch) => {
    dispatch(push('/profile/edit'));
  };
}
export function gotoProfilePassword() {
  return (dispatch) => {
    dispatch(push('/profile/password'));
  };
}
export function requestingProfile() {
  return {
    type: PROFILE_FETCH_REQUEST,
    payload: null,
  };
}
export function requestProfileSuccess(json) {
  return {
    type: PROFILE_FETCH_SUCCESS,
    payload: json,
  };
}
export function requestProfileFailure(json) {
  return {
    type: PROFILE_FETCH_FAILURE,
    payload: json,
  };
}
export function requestProfile() {
  return (dispatch) => {
    dispatch(requestingProfile());
    return fetchProfile()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(requestProfileSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              return dispatch(requestProfileFailure(detail));

            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              return dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
        Promise.resolve();
        // TODO: we need a promise here because of the tests, find a better way
      });
  };
}
export function passwordSetRequest() {
  return {
    type: PASSWORD_SET_REQUEST,
    payload: null,
  };
}
export function passwordSetSuccess(json) {
  return {
    type: PASSWORD_SET_SUCCESS,
    payload: json,
  };
}
export function passwordSetFailure(json) {
  return {
    type: PASSWORD_SET_FAILURE,
    payload: json,
  };
}

export function setPassword(user, payload) {
  return (dispatch) => {
    dispatch(passwordSetRequest());
    return postSetPassword(user, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(passwordSetSuccess(response));
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Password Set',
          message: 'Your password has been updated.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        return dispatch(push('/profile'));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              dispatch(passwordSetFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        }
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Yikes!',
          message: 'Ugh. Unable to set password. Try again later.',
          autoDismiss: 0,
        };
        return dispatch(Notifications.error(notificationOpts));
      });
  };
}

export function profileEditRequest() {
  return {
    type: PROFILE_EDIT_REQUEST,
    payload: null,
  };
}
export function profileEditSuccess(json) {
  return {
    type: PROFILE_EDIT_SUCCESS,
    payload: json,
  };
}
export function profileEditFailure(json) {
  return {
    type: PROFILE_EDIT_FAILURE,
    payload: json,
  };
}


export function editProfile(user, payload) {
  return (dispatch) => {
    dispatch(profileEditRequest());
    return patchProfile(user, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(profileEditSuccess(response));
        dispatch(authUpdateUser(response));
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Profile Updated',
          message: 'Your profile has been updated.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        return dispatch(push('/profile'));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              dispatch(profileEditFailure(detail));
              throw new SubmissionError(detail);
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              return dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        }
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Yikes!',
          message: 'Ugh. Unable to edit profile. Try again later.',
          autoDismiss: 0,
        };
        return dispatch(Notifications.error(notificationOpts));
      });
  };
}

export function editProfileImage(user, payload) {
  return (dispatch) => {
    dispatch(profileEditRequest());
    return uploadProfileImage(user, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(profileEditSuccess(response));
        dispatch(authUpdateUser(response));
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Profile Updated',
          message: 'Your profile has been updated.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        return dispatch(push('/profile'));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              dispatch(profileEditFailure(detail));
              throw new SubmissionError(detail);
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              return dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        }
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Yikes!',
          message: 'Ugh. Unable to edit profile. Try again later.',
          autoDismiss: 0,
        };
        return dispatch(Notifications.error(notificationOpts));
      });
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PROFILE_FETCH_REQUEST]: state => update(
      state,
    {
      $set:
      {
        needFetch: false,
        isFetching: true,
        profile: {},
      },
    },
    ),
  [PROFILE_FETCH_SUCCESS]: (state, action) => {
    if (action.payload.length !== 0) {
      return update(
        state,
        {
          $set:
          {
            needFetch: false,
            isFetching: false,
            selectedProfile: action.payload[0],
          },
        },
      );
    }
    return state;
  },
  [PROFILE_EDIT_SUCCESS]: (state, action) => {
    return update(
      state,
      {
        $set:
        {
          needFetch: false,
          isFetching: false,
          selectedProfile: action.payload,
        },
      },
    );
  },

  // [TOUR_FETCH_SUCCESS]: (state, action) => update(state, {
  //   selectedTour: { $set:
  //   { id: action.payload.id,
  //     isFetching: false,
  //     needFetch: false,
  //     tour: action.payload } },
  // }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: true,
  needFetch: true,
  profile: {
    id: null,
  },
};

export default function registerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// src/routes/profile/modules/profile.js